module.exports = __webpack_public_path__ + "media/images/home-6eab2f2f0537d2da3cf0eb392d14dca1.jpg";